import React from "react";
import ReusableDataTable from "../../hooks/ReusableDataTable";
import { Button, Checkbox, Label, Modal, TextInput, Textarea } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import '../../style/model.css';
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import axios from "axios";
import useInputValidation from "../../hooks/useInputValidation";
import { useSidebar } from "../../context/SidebarOpenContext";
function Vendor() {
    const navigate = useNavigate();
    const [AddModal, setAddModal] = useState(false);
    const [EditModal, setEditModal] = useState(false);
    const [DeleteModal, setDeleteModal] = useState(false);
    const [Input, setInput] = useState({});
    const [EditInput, setEditInput] = useState({});
    const [Vendor, setVendor] = useState({});
    const { errors, handleChange, resetErrors } = useInputValidation();
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const gstRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d{1}[A-Z]{1}[A-Z0-9]{1}$/;
    const [gstError, setGstError] = useState('');
    useEffect(() => {
        fetchVendor();
    }, []);


    // const onChangeValue = (e) => {
    //     handleChange(e);
    //     setInput({ ...Input, [e.target.name]: e.target.value });
    // }
    const onChangeValue = (e) => {
        const { name, value } = e.target;
        const updatedInput = { ...Input, [name]: value };

        if (name === "gst_no") {
            updatedInput.gst_type = value.startsWith("33") ? "GST" : "IGST";
        }
        if (name === "gst_no") {
            if (value === "") {
                setGstError("GST No is required");
            } else if (!gstRegex.test(value)) {
                setGstError("Invalid GST format");
            } else {
                setGstError("");
            }
        }
        handleChange(e);
        setInput(updatedInput);
    };
    const onEditChangeValue = (e) => {
        handleChange(e);
        const { name, value } = e.target;
        const updatedSupplier = { ...EditInput, [name]: value };

        if (name === "gst_no") {
            const prefix = value.slice(0, 2);
            updatedSupplier.gst_type = prefix === "33" ? "GST" : "IGST";
        }
        if (name === "gst_no") {
            if (value === "") {
                setGstError("GST No is required");
            } else if (!gstRegex.test(value)) {
                setGstError("Invalid GST format");
            } else {
                setGstError("");
            }
        }
        setEditInput(updatedSupplier);
    };

    const fetchVendor = async () => {
        try {
            const response = await axios.get("master/vendors");
            const VendorData = response.data;
            setVendor(VendorData);
        } catch (error) {
            console.error("Error fetching Vendor data:", error);
        }
    };

    const addVendor = async (event) => {
        event.preventDefault();
        try {
            axios
                .post(`master/vendors`, {
                    vendor_name: Input.name,
                    vendor_no: Input.vendor_no,
                    phone_no: Input.phoneno,
                    gst_no: Input.gst_no,
                    gst_type: Input.gst_type,
                    address: Input.address
                })
                .then((res) => {
                    if (res.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Vendor  Created",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        setAddModal(false);
                        fetchVendor();


                    } else if (res.data.success === 2 || res.data.success === 4) {
                        Swal.fire({
                            icon: "error",
                            text: res.data.message,
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }

    };

    const UpdateVendor = async (event) => {
        event.preventDefault();

        try {
            axios
                .put(`master/vendors/${EditInput.id}`, {
                    vendor_name: EditInput.name,
                    vendor_no: EditInput.vendor_no,
                    phone_no: EditInput.phoneno,
                    address: EditInput.address,
                    id: EditInput.id,
                    gst_no: Input.gst_no,
                    gst_type: Input.gst_type,
                })
                .then((res) => {
                    if (res.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Vendor  Details Updated",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        setEditModal(false);
                        fetchVendor();
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }

    };

    const deletVendor = async () => {
        try {
            axios.delete(`master/vendors/${EditInput.id}`).then((res) => {
                if (res.data.success === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Vendor  deleted",
                        type: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    fetchVendor();
                    setDeleteModal(false);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: "Server Problem. Please Try Again...",
                        type: "error",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                }
                return;
            });
        } catch (error) {
            throw error;
        }
    };


    const data = Array.isArray(Vendor)
        ? Vendor.map((V) => ({
            id: V.vendor_id,
            name: V.vendor_name,
            vendor_no: V.vendor_no,
            phoneno: V.phone_no,
            gst_no: V.gst_no,
            gst_type: V.gst_type,
            address: V.address,
            option: (<div style={{ display: "flex" }}>
                <FaPen className="text-amber-400 text-xl" onClick={() => {
                    setEditModal(true); setEditInput({
                        id: V.vendor_id,
                        name: V.vendor_name,
                        vendor_no: V.vendor_no,
                        gst_no: V.gst_no,
                        gst_type: V.gst_type,
                        phoneno: V.phone_no,
                        address: V.address
                    });
                }} />
                <MdDeleteForever className="ml-2 text-red-500 text-2xl" onClick={() => { setDeleteModal(true); setEditInput({ id: V.vendor_id }) }} />
            </div>)
        }))
        : [];

    const columns = [
        { name: "S.No", selector: (row, index) => index + 1, sortable: true },
        { name: "Vendor Name", selector: (row) => row.name, sortable: true },
        { name: "Vendor Id", selector: (row) => row.vendor_no },
        { name: "Phone No", selector: (row) => row.phoneno, sortable: true },
        { name: "GST No", selector: (row) => row.gst_no, sortable: true },
        { name: "Address", selector: (row) => row.address, sortable: true },
        { name: "Option", selector: (row) => row.option },
    ];

    return (
        <div className={` ${isSidebarOpen ? "p-4 sm:ml-64 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >

            <div className="p-4 rounded-lg dark:border-gray-700  mt-14">
                <div className="p-4 rounded-lg shadow bg-white">
                    <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" onClick={() => setAddModal(true)} >Add Vendor</Button>
                    <ReusableDataTable
                        title="Vendor List"
                        columns={columns}
                        data={data}
                    />
                </div>
            </div>

            <Modal show={AddModal} size="md" onClose={() => { setAddModal(false); resetErrors(); }} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Add Vendor</h3>
                        <form onSubmit={addVendor}>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.name && "failure"} value="Vendor Name" />
                                </div>
                                <TextInput
                                    id="name"
                                    name="name"
                                    placeholder=""
                                    type="text"
                                    required
                                    color={errors.name && "failure"}
                                    helperText={
                                        errors.name && (
                                            <>
                                                <span className="font-medium"></span> {errors.name}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                    pattern="^[A-Za-z\s]*$"
                                />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.vendor_no && "failure"} value="Vendor Id" />
                                </div>
                                <TextInput
                                    id="vendor_no"
                                    name="vendor_no"
                                    placeholder=""
                                    type="text"
                                    required
                                    color={errors.vendor_no && "failure"}
                                    helperText={
                                        errors.vendor_no && (
                                            <>
                                                <span className="font-medium"></span> {errors.vendor_no}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}

                                />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="phoneno" value="Phone Number" color={errors.phoneno && "failure"} />
                                </div>
                                <TextInput
                                    id="phoneno"
                                    color={errors.phoneno && "failure"}
                                    name="phoneno"
                                    type="text"
                                    required
                                    maxLength={10}
                                    helperText={
                                        errors.phoneno && (
                                            <>
                                                <span className="font-medium"></span> {errors.phoneno}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                    pattern="^[6-9]\d{9}$" />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="gst_no" value="GST No" />
                                </div>
                                <TextInput
                                    id="gst_no"
                                    name="gst_no"
                                    type="text"
                                    value={Input.gst_no}
                                    onChange={onChangeValue}
                                    color={gstError ? 'failure' : 'default'}
                                    helperText={gstError && <span>{gstError}</span>}
                                />
                            </div>


                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="gst_type">GST Type : {Input.gst_type}</Label>
                                </div>
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="phoneno" value="Address"
                                    //  color={errors.address && "failure"} 
                                     />
                                </div>
                                <Textarea
                                    id="address"
                                    name="address"
                                    // color={errors.address && "failure"}
                                    // helperText={
                                    //     errors.address && (
                                    //         <>
                                    //             <span className="font-medium"></span> {errors.address}
                                    //         </>
                                    //     )
                                    // }
                                    onChange={onChangeValue}
                                    // pattern="^[a-zA-Z0-9\s,.-/]{5,100}$"
                                    required rows={4} />
                            </div>

                            <div className="pt-2 w-full flex justify-center">
                                <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" type="submit">Submit</Button>
                                <Button className="ml-2" color="gray" onClick={() => { setAddModal(false); resetErrors(); }}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={EditModal} size="md" onClose={() => { setEditModal(false); resetErrors(); }} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Update Vendor</h3>
                        <form onSubmit={UpdateVendor}>
                            <div>
                                <div className="mt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.name && "failure"} value="Vendor Name" />
                                </div>
                                <TextInput
                                    id="name"
                                    name="name"
                                    placeholder=""
                                    type="text"
                                    required
                                    onChange={onEditChangeValue}
                                    value={EditInput.name}
                                    color={errors.name && "failure"}
                                    helperText={
                                        errors.name && (
                                            <>
                                                <span className="font-medium"></span> {errors.name}
                                            </>
                                        )
                                    }
                                    pattern="^[A-Za-z\s]*$"

                                />
                            </div>
                            <div>
                                <div className="mt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.vendor_no && "failure"} value="Vendor Id" />
                                </div>
                                <TextInput
                                    id="vendor_no"
                                    name="vendor_no"
                                    placeholder=""
                                    type="text"
                                    required
                                    onChange={onEditChangeValue}
                                    value={EditInput.vendor_no}
                                    color={errors.vendor_no && "failure"}
                                    helperText={
                                        errors.vendor_no && (
                                            <>
                                                <span className="font-medium"></span> {errors.vendor_no}
                                            </>
                                        )
                                    }


                                />
                            </div>
                            <div>
                                <div className="mt-2 mb-2 block">
                                    <Label htmlFor="phoneno" value="Phone Number" />
                                </div>
                                <TextInput
                                    id="phoneno"
                                    name="phoneno"
                                    value={EditInput.phoneno}
                                    color={errors.phoneno && "failure"}
                                    type="text"
                                    required
                                    maxLength={10}
                                    helperText={
                                        errors.phoneno && (
                                            <>
                                                <span className="font-medium"></span> {errors.phoneno}
                                            </>
                                        )
                                    }
                                    onChange={onEditChangeValue}
                                    pattern="^\d{10}$" />

                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="gst_no" value="GST No" />
                                </div>
                                <TextInput
                                    id="gst_no"
                                    name="gst_no"
                                    type="text"
                                    value={EditInput.gst_no}
                                    onChange={onEditChangeValue}
                                />
                            </div>

                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="gst_type">GST Type : {EditInput.gst_type}</Label>
                                </div>
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="phoneno" value="Address" />
                                </div>
                                <Textarea
                                    id="address"
                                    name="address"
                                    value={EditInput.address}
                                    // color={errors.address && "failure"}
                                    // helperText={
                                    //     errors.address && (
                                    //         <>
                                    //             <span className="font-medium"></span> {errors.address}
                                    //         </>
                                    //     )
                                    // }
                                    onChange={onEditChangeValue}
                                    // pattern="^[a-zA-Z0-9\s,.-/]{5,100}$"
                                    required rows={4} />
                            </div>
                            <div className="mt-2 w-full flex justify-center">
                                <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" type="submit">Submit</Button>
                                <Button className="ml-2" color="gray" onClick={() => { setEditModal(false); resetErrors(); }}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={DeleteModal} size="md" onClose={() => setDeleteModal(false)} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            Are you sure you want to delete this Vendor?
                        </h3>
                        <div className="flex justify-center gap-4">
                            <Button color="failure" onClick={() => deletVendor()}>
                                {"Yes"}
                            </Button>
                            <Button color="gray" onClick={() => setDeleteModal(false)}>
                                No
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </div>


    );
}

export default Vendor;
